export default "__VITE_ASSET__DnUl2j6n__"